var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetGif(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 7,
    viewBox: "0 0 16 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 0.875C6 0.396667 5.592 0 5.1 0H1.2C0.48 0 0 0.583333 0 1.16667V5.83333C0 6.41667 0.48 7 1.2 7H4.8C5.52 7 6 6.41667 6 5.83333V4.375C6 3.89667 5.592 3.5 5.1 3.5C4.608 3.5 4.2 3.89667 4.2 4.375V5.25H1.8V1.75H5.1C5.592 1.75 6 1.35333 6 0.875ZM8 0C8.54667 0 9 0.396667 9 0.875V6.125C9 6.60333 8.54667 7 8 7C7.45333 7 7 6.60333 7 6.125V0.875C7 0.396667 7.45333 0 8 0ZM15.1667 0C15.6222 0 16 0.396667 16 0.875C16 1.35333 15.6222 1.75 15.1667 1.75H12.6667V2.91667H14.0556C14.5111 2.91667 14.8889 3.31333 14.8889 3.79167C14.8889 4.27 14.5111 4.66667 14.0556 4.66667H12.6667V6.125C12.6667 6.60333 12.2889 7 11.8333 7C11.3778 7 11 6.60333 11 6.125V1.16667C11 0.525 11.5 0 12.1111 0H15.1667Z",
    fill: "#2E2B63"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetGif);
export default __webpack_public_path__ + "static/media/getGif.6602c7059085ea7981711ec5bceba989.svg";
export { ForwardRef as ReactComponent };